import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { IAssemblyComponent } from 'src/interfaces';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export const useGetAssemblyComponentsById = (
  assemblyComponentIds: number[],
) => {
  return useQuery({
    queryKey: queryKeys.assemblyComponents.all(
      `list=${assemblyComponentIds.join('|')}`,
    ),
    queryFn: () => fetchAssemblyComponentsById(assemblyComponentIds),
    enabled: !isEmpty(assemblyComponentIds),
  });
};

const fetchAssemblyComponentsById = async (assemblyComponentIds: number[]) => {
  const url = `/assemblyComponents?id.list=${assemblyComponentIds.join(
    '|',
  )}&pageSize=0`;

  const response = await requestCCApi({ url });

  return response.data as IAssemblyComponent[];
};
